module.exports = __webpack_public_path__ + "img/项目合作.514f0b88.jpg";